exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".getting-discount span.mdi.mdi-name.error {\n  border: 1px solid #ff0000;\n}\n.getting-discount .selected-partners .partner .remove-partner {\n  margin-top: -5px;\n  cursor: pointer;\n}\n.getting-discount #map.error {\n  border: 1px solid #ff0000;\n}\n@media screen and (max-width: 599px) {\n  .getting-discount .mobil-pb-5 {\n    padding-bottom: 0px !important;\n  }\n  .getting-discount h3 {\n    font-size: 20px;\n  }\n}\n", ""]);

// exports
